import { useCallback, useEffect, useMemo, useRef } from "react";
import { connect } from "react-redux";
import { Icon } from "../../shared/Icon";
import * as ewcms from "../EWCMS/styleMaster";
import {
  logoutAction,
  navigateAction,
  refreshCsrf,
} from "../../../redux/actions";
import { Dropdown } from "antd";
import { label } from "../../../framework";

function Logout(props: any) {
  const { device, netId, logout, csrf } = props;

  const polyuColor: string = ewcms.polyuRed;
  const CHECK_DURATION_SECS: number = 60;
  const NO_OF_CHECKING: number = 30;

  const dropDownIcon = useMemo(
    () => (
      <Icon
        type="CaretDownOutlined"
        style={{ color: polyuColor, fontSize: "8px" }}
      />
    ),
    []
  );
  let myTimer = useRef<NodeJS.Timeout | null>(null);

  const timeOutFunction = useCallback(
    (index: number) => {
      myTimer.current = setTimeout(() => {
        if (index > 0) {
          timeOutFunction(index - 1);
          refreshCsrf();
        }
      }, CHECK_DURATION_SECS * 1000);
    },
    [myTimer, refreshCsrf]
  );

  useEffect(() => {
    timeOutFunction(NO_OF_CHECKING);
  }, [timeOutFunction]);

  const onLogoutClick = (e) => {
    if (e.key === "logout" && myTimer.current) {
      clearTimeout(myTimer.current);
      logout(csrf);
    }
  };

  const logoutMenu = () => {
    const dropdownMenuStyle = {
      fontSize: "0.875rem",
      justifyContent: "flex-start",
    };
    const dropdownIconStyle = { color: polyuColor, fontSize: "12px" };

    let logoutItems = [
      {
        key: "logout",
        label: (
          <span className="cust-vertical-center" style={dropdownMenuStyle}>
            <Icon type="LogoutOutlined" style={dropdownIconStyle} />
            &nbsp;{label("LB0010")}
          </span>
        ),
      },
    ];

    return (
      <Dropdown
        menu={{
          items: logoutItems,
          onClick: onLogoutClick,
          triggerSubMenuAction: device.size === "desktop" ? "hover" : "click",
        }}
        trigger={device.size === "desktop" ? ["hover"] : ["click"]}
        key="hb_lm"
      >
        {
          <span
            className="cust-vertical-center selectCurosr"
            style={{ display: "flex" }}
          >
            <Icon type="UserOutlined" style={dropdownIconStyle} />
            &nbsp;{netId} &nbsp;{dropDownIcon}
          </span>
        }
      </Dropdown>
    );
  };

  return logoutMenu();
}

const mapStateToProps = (state) => {
  return {
    /*Permission: assign different permission as inputter and approver*/
    netId: state.session.netId,
    csrf: state.action.csrf,
    device: state.session.device,
  };
};

const mapDispatchToProps = (dispatch) => ({
  logout: (csrf) => {
    dispatch(logoutAction(csrf));
  },
  refreshCsrf: () => {
    dispatch(refreshCsrf());
  },
  navigate: (toFunctions) => {
    dispatch(navigateAction(toFunctions));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
